module.exports = __webpack_public_path__ + "static/media/alycore04.f4e03adc.png";